import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="bg-arena pt-[120px] md:pt-[192px] pb-20 md:pb-[120px]" data-id="element-29">
      <div className="max-w-[720px] mx-auto px-6 md:px-20 text-center" data-id="element-30">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} data-id="element-31">
          <span className="block font-body text-[11px] uppercase font-medium text-salvia tracking-widest mb-6" data-id="element-32">
            DIAGNÓSTICO ICD™
          </span>

          <h1 className="font-display text-[40px] md:text-[64px] font-bold text-carbon leading-[1.05] tracking-tightest mb-6" data-id="element-33">
            Descubre la puntuación digital de tu empresa.
          </h1>

          <p className="font-body text-[18px] md:text-[20px] text-carbon/65 leading-[1.6] mb-10" data-id="element-34">
            En 48 horas recibirás el análisis completo de las cinco dimensiones
            de tu presencia digital, con recomendaciones específicas para tu
            empresa.
          </p>

          {/* Progress Indicator */}
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6 mb-8" data-id="element-35">
            <div className="flex items-center gap-2" data-id="element-36">
              <span className="font-body text-[13px] font-medium text-verde" data-id="element-37">
                1 Solicitud
              </span>
            </div>
            <span className="hidden md:block text-carbon/20" data-id="element-38">→</span>
            <div className="flex items-center gap-2" data-id="element-39">
              <span className="font-body text-[13px] font-medium text-carbon/30" data-id="element-40">
                2 Análisis 48h
              </span>
            </div>
            <span className="hidden md:block text-carbon/20" data-id="element-41">→</span>
            <div className="flex items-center gap-2" data-id="element-42">
              <span className="font-body text-[13px] font-medium text-carbon/30" data-id="element-43">
                3 Recibe Informe
              </span>
            </div>
          </div>

          <p className="font-body text-[13px] text-carbon/45 italic" data-id="element-44">
            Análisis realizado por el equipo de Origen Studio. No automatizado.
            No genérico.
          </p>
        </motion.div>
      </div>
    </section>;
}